import { useEffect } from 'react';
import { useStore } from '@nanostores/react';
import {
  Panel,
  PanelHeader,
  PanelTitle,
  PanelDescription,
  PanelSection,
  Box,
} from '@customerio/pluma-components/react';
import { DocumentTitle } from '@/components/page/document-title';
import { AddPeopleActions } from '@/features/add-people';
import { useAnalytics } from '@/services/analytics';
import { billing } from '@/services/billing';

/**
 * The migrated `/profiles/create` page — Ember's `people.create` route. Unlike
 * the onboarding page at `/home/add-people`, this one hides the integrations
 * grid for Builder-plan accounts, matching Ember's `billing.isBuilder` branch.
 */
export default function PeopleCreatePage() {
  const { track } = useAnalytics();
  const isBuilder = useStore(billing.isBuilder);

  useEffect(() => {
    void track('people', 'addPeopleModalViewed', {});
    // oxlint-disable-next-line react/exhaustive-deps
  }, []);

  const handleActionClick = (title: string) => {
    void track('people', 'addPeopleActionClicked', {
      'Action Name': title,
      'Page Name': 'people.create',
    });
  };

  return (
    <>
      <DocumentTitle title="Add people" />
      <Box p="200">
        <Panel>
          <PanelHeader>
            <PanelTitle level="1">Add people</PanelTitle>
            <PanelDescription>
              Real-time people and event data is the foundation of timely and relevant messages.
            </PanelDescription>
          </PanelHeader>

          <PanelSection>
            <AddPeopleActions isBuilder={isBuilder} onActionClick={handleActionClick} />
          </PanelSection>
        </Panel>
      </Box>
    </>
  );
}
